<template>
  <Header />
  <article>
    <div class="kv">
      <div class="caption">
        <h1>我們的責任</h1>
      </div>
    </div>
    <section class="sect1">
      <div class="ctx">
        <div class="sectTit">撐起全台灣 4% 穩定用電</div>
        <p>台灣北部因陽明山、淡水河、雪山山脈的區隔，受到天然屏障限制，自然形成北東電網及北西電網，而和平電力隸屬於北東電網，供應台灣北部兩大重要城市 - 宜蘭約 95% 以及新北市約 20% 的用電需求，佔全台近 4% 的電力供應量。</p>
      </div>
    </section>
    <section class="sect2">
      <div class="ctx">
        <div class="imgContainer2-1"></div>
        <div class="left">
          <div>北北基桃宜千萬人口，依賴北東、北西兩大電網支撐，近年人口成長，區內至少有 263 萬用戶，供電壓力持續攀升，台電曾表示隨著核二廠2 部機組已到年限停機，未來協和 3、4 號機再除役，北東電網內的自發電源只剩和平電廠，不足電力只能依靠台灣北西或中部的電廠供電，但供電的距離越長，除了電力損耗外，從北西到北東，電網融通能力的上限僅 420 萬瓩，和平電廠若再遇到像是 2024 年 4 月花蓮強震等天然變數，北東電力將不足，北北基地區恐優先列入「分區限電」。</div>
          <p>和平電廠所產生之電力，全部躉售予台電，協助台電大幅改善北東地區供電情形，並能減緩西部地區 345 kV 超高壓南北幹線輸電量，提高台灣電力供應系統之穩定度。即便在 2022 年極端國際情勢期間煤價高漲 3-4 倍（2019 年煤價基準價格飆升近 160%），和平電廠在承擔虧損的壓力下，持續依合約供電善盡企業社會責任。</p>
        </div>
        <div class="right">
          <div class="imgContainer2-2"></div>
        </div>
        <div class="clear"></div>
      </div>
    </section>
    <section class="sect3">
      <div class="ctx">
        <div class="imgContainer3-1">
          <div class="imgTit">和平電力廠區夜間全景</div>
        </div>
        <div class="sectTit">和平電廠在再生能源轉型過程中，承擔穩定供電社會責任</div>
        <p>根據台灣經濟部最新全國電力資源供需報告，至 2033 年全台火力機組轉型及除役計畫中，和平電廠仍是北東電網不可替代的主要供電來源。在和平電廠與台電多次交流討論中，和平電廠深刻理解資源有限的台灣，能源轉型的困難與實際進程。和平電廠母公司台泥致力於淨零轉型，為台灣目前發展再生能源項目最多元的企業，但也須善盡企業社會責任，以和平電廠持續運轉協助台灣於能源轉型過程中仍能穩定供電，維護宜蘭 95% 及新北市 20% 民眾用電權益。</p>
        <p>因此，和平電廠將依 IEA 國際能源總署建議、並配合台電續約與電網穩定需求，計畫和平電廠燃煤機組至遲運轉至 2040 年設計年限止，機組關閉時間不晚於 2040 年。和平電廠也將啟動公正轉型計畫，透過多元的溝通形式瞭解員工與相關利害關係人面臨之課題。和平電廠 2024 年底啟動的海洋溫差發電計畫，亦將是未來轉型計畫重要的一部分。</p>
      </div>
    </section>
  </article>
  <Footer />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ImgContainerAutoResize } from '../../util/util';
import Header from '../../components/Header.vue';
import Footer from '../../components/Footer.vue';

export default defineComponent({
  name: 'EnergyTransitionResponsibility',
  components: {
    Header,
    Footer
  },
  data() {
    return {
    }
  },
  methods:{
  },
  mounted() {
    new ImgContainerAutoResize(document.querySelector(".kv") as HTMLElement, 0.368);
    new ImgContainerAutoResize(document.querySelector(".imgContainer2-1") as HTMLElement, 0.7);
    new ImgContainerAutoResize(document.querySelector(".imgContainer2-2") as HTMLElement, 0.72);
    new ImgContainerAutoResize(document.querySelector(".imgContainer3-1") as HTMLElement, 0.55);
  }
});
</script>

<style>
.kv {
  height: 700px;
  position: relative;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5) 0, rgba(0, 0, 0, 0) 20%), url("@/assets/energyTransitionResponsibility/kv.webp");
  background-position: center, center 35%;
  background-size: cover, cover;
}

.kv .caption {
  width: 1200px;
  margin: 0 auto;
  padding: 25px 0;
  box-sizing: border-box;
}

.kv .caption h1 {
  margin: 0;
  display: inline-block;
  letter-spacing: 5px;
  font-weight: bold;
  font-size: 52px;
  color: #fff;
  text-shadow: 5px 5px 5px #00000066;
}

.sect1 {
  background: #F4F3F3;
}

.sect1 .sectTit {
  margin: 0 0 10px;
  padding: 5px 0;
  box-sizing: border-box;
  display: inline-block;
  border-top: solid 1px #0C5F99;
  border-bottom: solid 1px #0C5F99;
  letter-spacing: 2px;
  font-size: 24px;
  color: #0C5F99;
}

.sect1 p {
  line-height: 2em;
}

.sect2 {
}

.sect2 .imgContainer2-1 {
  width: 75%;
  margin: 0 auto 60px;
  background: url(../../assets/energyTransitionResponsibility/pic2_01.png) center no-repeat;
  background-size: cover;
}

.sect2 .left {
  width: 40%;
  float: left;
  line-height: 2em;
  letter-spacing: 1px;
}

.sect2 .right {
  width: 55%;
  float: right;
}

.sect2 .right .imgContainer2-2 {
  margin: 0 auto;
  background: url(../../assets/energyTransitionResponsibility/pic2_02.png) center no-repeat;
  background-size: cover;
}

.sect3 {
  background: #F4F3F3;
}

.sect3 p {
  line-height: 2em;
}

.sect3 .imgContainer3-1 {
  margin: 0 auto 60px;
  position: relative;
  border-radius: 30px;
  overflow: hidden;
  background: url(../../assets/energyTransitionResponsibility/pic3_01.jpg) center bottom no-repeat;
  background-size: cover;
}

.sect3 .imgContainer3-1 .imgTit {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  text-align: center;
  color: #fff;
  background: #00000066;
}

.sect3 .sectTit {
  margin: 0 0 10px;
  padding: 5px 0;
  box-sizing: border-box;
  display: inline-block;
  border-top: solid 1px #0C5F99;
  border-bottom: solid 1px #0C5F99;
  letter-spacing: 2px;
  font-size: 24px;
  color: #0C5F99;
}

@media screen and (min-width: 1367px) and (max-width: 1600px) {
  .kv .caption h1 {
    font-size: 48px;
  }
}

@media screen and (min-width: 1201px) and (max-width: 1366px) {
  .kv .caption h1 {
    font-size: 44px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 40px;
  }

  .sect2 .ctx {
    padding: 20px 40px;
  }

  .sect2 .imgContainer2-1 {
    width: 100%;
    margin: 0 auto 40px;
  }

  .sect2 .left {
    width: 100%;
  }

  .sect2 .right {
    width: 100%;
  }
}

@media screen and (min-width: 1px) and (max-width: 767px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 24px;
    text-shadow: 3px 3px 3px #00000066;
  }

  .sect2 .ctx {
    padding: 0 20px 40px;
  }

  .sect2 .imgContainer2-1 {
    width: 100%;
    margin: 0 auto 40px;
  }

  .sect2 .left {
    width: 100%;
  }

  .sect2 .right {
    width: 100%;
  }

  .sect2 .right .imgContainer2-2 {
    margin: 0 auto;
    background: url(../../assets/energyTransitionResponsibility/pic2_02.png) center no-repeat;
    background-size: cover;
  }
}
</style>
